import {
  Box,
  Center,
  Spinner,
} from '@chakra-ui/react';
import FFLDetail from '../ffl-detail/FFLDetail';
import React, { useEffect } from 'react';
import { useFFLDetailClient } from '@/api/backoffice-api';
import AppConfig from '@/utils/app-config.mjs';
import { setIsSearchStarted, setSearchCount } from '../ducks/slice';
import { useDispatch } from 'react-redux';

interface Props {
  first1: string;
  second2: string;
  last5: string;
  cognitoGroup: boolean;
  isSuperAdmin: boolean;
}

export default function LicenseNumberResult({
  first1,
  second2,
  last5,
  cognitoGroup,
  isSuperAdmin
}: Props) {
  const dispatch = useDispatch();
  const [{ loading, error, data }] = useFFLDetailClient({
    baseURL: AppConfig.fflGetApiBaseURL,
    url: `/license/${first1}${second2}/${last5}`
  });
  useEffect(() => {
    if (loading) {
      dispatch(setIsSearchStarted(true));
    } else if (error) {      
      dispatch(setSearchCount(-1))
      dispatch(setIsSearchStarted(false));
    } else if (data) {
      dispatch(setSearchCount(1))
      dispatch(setIsSearchStarted(false));
    }
  }, [loading, data, error, dispatch]);

  function renderResult() {
    if (error) {
      const errorMessage =
        error?.response?.status === 404
          ? `No licensee found matching license number ${first1}-${second2}-xxx-xx-xx-${last5}`
          : `We're sorry. An unexpected error occurred. Please try again, or contact support.`;
      return <Box>{errorMessage}</Box>;
    }
    if (loading) {
      return (
        <Center height={'50vh'}>
          <Spinner />
        </Center>
      );
    }
    
    return (
      <FFLDetail
        data={data[0]}
        cognitoGroup={cognitoGroup}
        isSuperAdmin={isSuperAdmin}
      />
    );
  }

  return (
    <Box className={'ZipCodeResults'}>
      {renderResult()}
    </Box>
  );
}
